import { h } from "preact"
import './timeline-styles.scss'
import { DateTime } from 'luxon'
import { downloadFileFtp } from '../../../_rx/fct/actions'
import { t } from '../../../_i18n'
import { useSelector } from 'react-redux'
import { useEffect} from "preact/hooks";
import { Route, Switch, useLocation } from "react-router-dom";
import {isMobileAgent} from "../../../_common/common";
import CardHelp from "../../../_common/components/CardDashboard/CardHelp";
import AlertBox from "../../../_common/components/AlertBox/AlertBox";

export default function Message ({ id, type, title, message_direction, read, date, body, attached }) {
  const { lang } = useSelector(state => state);
  const { pathname, hash, key } = useLocation();

  useEffect(() => {
    if (hash !== '') {
      setTimeout(() => {
        const id = hash.replace('#', '');
        const element = document.getElementById(id);
        if (element) {
          element.scrollIntoView( {behavior: "smooth"} );
        }
      }, 0);
    }
  }, [pathname, hash, key]);

  return (
    <a id={id} name={id} className="mobile-fct-message-wrapper">
      <div className='fct-message'>
        <div className='icon-container'>
          {!read && <i className="fas fa-circle font-12 font-color-33B9D3"/>}
          <div className='icon'>{type === 'event' ? <i className="far fa-check"/> : <i className="far fa-comment" />}</div>
          <div className='line'><div /></div>
        </div>
        <div className='content'>
          <div className="d-flex flex-space-between mobile">
            <div className="content__title bold">{title}</div>
            <div className="content__date">
              {DateTime.fromISO(date.replace(' ', 'T')).setLocale(lang).toFormat(t("fct_date_timeline"))}
            </div>
          </div>
          {body && <div className="content__body" dangerouslySetInnerHTML={{__html: body}}/>}
          {attached.length !== 0 && (
              <div className='content__attached_docs'>
                {attached.map(file => <div
                    onClick={() => downloadFileFtp(file.id, file.file_name)}>{file.file_name}</div>)}
              </div>
          )}
          {message_direction === 'mentores' &&
              <AlertBox type={"shadow"}>
                <div className="info-container flex-center-y">
                  <i className="far fa-info-circle m-r-half"></i>
                  {t('Este mensaje fue recibido en el correo de empresas y lo hemos importado aquí para poder gestionarlo mejor.')}
                </div>
              </AlertBox>

          }
        </div>
      </div>
    </a>
  )
}
